import {on} from "../utils.ts"
import {translateService} from '../service/TranslateService.ts'
import {LanguageShortCodeType} from "../types/language-short-code.type.ts";

class LangTemplate {
	getHtml (name: string, shortCode: LanguageShortCodeType, active: LanguageShortCodeType) {
		return /* html */ `
		<a  ${on('click', translateService, 'translate', shortCode)}
			class="${active == shortCode ? 'GoogleTranslate__item--active' : ''} GoogleTranslate__item notranslate" 
			href='' 
		>
			<img src="/modules/googletranslate/assets/${shortCode}.svg" alt="${name} flag" />
			<span>${name}</span>
		</a>
		`
	}
}

const langTemplate = new LangTemplate()
export {
	LangTemplate,
	langTemplate
}
